module.exports = __webpack_public_path__ + "assets/img/init_pos_floor3.1ec42aeb.png";